angular.module('bmsApp.marketing')
	.factory('MarketingSchemeSvc', function (CRUDSvc) {

		function index (params) {
			return CRUDSvc.get('api/marketing/scheme/index', params);
		}

		function options(params) {
			return CRUDSvc.get('api/marketing/scheme/options', params);
		}

		function read(params) {
			return CRUDSvc.get('api/marketing/scheme/read', params);
		}

		return {
			index: index,
			options: options,
			read: read,
		};

	});
